import { handleBulkTreatmentsSuccess, makeBulkTreatmentsRequest } from '../experiments/bulkTreatmentRequest';
import { EndpointKey } from './EndpointKey';
import { ExperimentActionTypes } from '../store/experiments/action-types';
export const EndpointsExperiments = {
  [EndpointKey.BulkExperimentRequest]: {
    reduxActionType: ExperimentActionTypes.FetchExperiments,
    method: makeBulkTreatmentsRequest,
    handleSuccess: handleBulkTreatmentsSuccess
  }
};